import {
    Box,
    Button,
    Dialog,
    Paper,
    Typography,
    InputAdornment,
    TextField
} from "@material-ui/core";
import AddBranchComponent from "../components/AddBranchComponent";
import {useAlert} from "react-alert";
import {sendActionEmail} from '../api/admin'
import {useEffect, useState} from "react";
import {useConfirm} from 'material-ui-confirm';
import {makeStyles} from "@material-ui/core/styles";
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import SearchIcon from '@material-ui/icons/Search';
import {deleteBranch, fetchBranches, validateBranch, toggleBranchVisibility} from "../api/branches";
import BranchCards from "../components/BranchCards";
import {fetchProviderInfo} from "../api/providerInfo";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '27.33%',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        '& .MuiSvgIcon-root': {
            color: theme.palette.text.secondary,
            marginRight: theme.spacing(1),
        }
    },
    secondaryHeading: {
        color: theme.palette.text.secondary,
        display: 'inline-flex',
        flexWrap: 'wrap',
        width: '100%',
        alignItems: 'center',
        '& div': {
            marginRight: theme.spacing(2),
        }
    },
    modalBox: {
        outline: 0,
        width: '100%',
        position: 'relative',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '1000px',
    },
    modalWrapper: {
        position: 'absolute',
        padding: theme.spacing(1),
        overflow: 'scroll',
        height: '100%',
        width: '100%',
        display: 'block'
    },
    topHeading: {
        display: 'flex',
        margin: theme.spacing(0.5, 0, 2, 0),
        alignItems: 'center',
    }
}));
export default function BranchesPage({providerId, user, handleUpdate, branchSearchBar}) {
    const classes = useStyles();
    const confirm = useConfirm();
    const [selectedBranch, setSelectedBranch] = useState({});
    const [createModalActive, setCreateModalActive] = useState(false);
    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState(branchSearchBar? branchSearchBar : '');
    const [sendingEmailToBranch, setSendingEmailToBranch] = useState('');
    const [providerInfo, setProviderInfo] = useState({});
    const alert = useAlert();
    const isAdmin = user?.roles?.includes('ROLE_ADMIN') || user?.roles?.includes('ROLE_AGENT') || user?.roles?.includes('ROLE_VALIDATOR');

    useEffect(() => {
        if (!!user) {
            setLoading(true);
            console.log("Not admin => fetch providerInfo")
            fetchProviderInfo(providerId, user.token).then(data => {
                console.log("RES", data)
                setProviderInfo(data)
            }).catch(() => {
                // means we got a non 2XX status code => provider info does not exist
                // => disable the navigation buttons
            }).finally(() => {
                setLoading(false);
            })
        }
        else {
            console.log("No user logged in");
        }
    }, [user]);

    const [branches, setBranches] = useState([]);
    useEffect(() => {
        if (!user || !providerId) {
            return
        }
        setLoading(true);
        fetchBranches(providerId, user.token, query).then(data => {
                setBranches(data);
                setLoading(false);
        })
    }, [providerId, query, user]);

    const handleOpen = () => {
        setCreateModalActive(true);
    };

    const onBranchUpdate = (branch) => {
        const updatedBranches = [...branches];
        const index = updatedBranches.findIndex(a => a._id === branch._id);
        if (index >= 0) {
            updatedBranches.splice(index, 1, branch);
        } else {
            updatedBranches.unshift(branch);
        }
        setBranches(updatedBranches)
    }


    const handleEdit = (branch) => () => {
        setSelectedBranch(branch);
        setCreateModalActive(true);
    }

    const handleVisibility = (branch) => () => {
        branch.visibility = !branch.visibility;
        toggleBranchVisibility(providerId, branch._id, user.token)
        onBranchUpdate(branch)
    }

    const handleDelete = (branch) => () => {
        return confirm({description: 'This action is permanent!'})
            .then(() => {
                console.log("Deleting", branch)
                return deleteBranch(providerId, branch, user.token).then(() => {
                    const updatedBranches = [...branches];
                    setBranches(updatedBranches.filter(a => a._id !== branch._id));

                })
            }).catch(() => console.log('delete cancelled'))
    }

    const handleValidate = (branch) => () => {
        const validateText = 'Please confirm the action, Once validated, the branch will be ready to be displayed in the app.'
        const invlidateText = 'Please confirm the action, Once invalidated, the branch will not be accessible by the app.'
        const description =  branch.manual_validation_flag ? invlidateText : validateText;
        return confirm({ description })
            .then(() => {
                return validateBranch(
                  providerId,
                  branch._id,
                  !branch.manual_validation_flag,
                  user.token
                ).then(() => {
                  setBranches((prev) =>
                    prev.map((item) => {
                      if (item._id === branch._id)
                        return {
                          ...item,
                          manual_validation_flag: !item.manual_validation_flag,
                        };
                      return item;
                    })
                  );
                }).catch(() => {
                    alert.error("Something went wrong, please try again later or contact the support!");
                })
            })
            .catch(() => {
                 console.log('validation cancelled.');
            })
    }

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        // clearing on close
        setSelectedBranch({});
        setCreateModalActive(false);
    };

    const handleSendActionEmail = async (branch) => {
        try {
            await confirm({description: `Are you sure you want to send welcome email to "${branch?.info?.contact?.contact_email}"`})
            setSendingEmailToBranch(branch._id)
            const res = await sendActionEmail(providerInfo._id, branch._id, user.token);
            if ( res.success ) {
                alert.show('Welcome email sent', {hideIcon: true});
            } else {
                alert.show(res.message)
            }
        } catch {
            console.log('Email sending cancelled');
        } finally {
            console.log("Done")
            setSendingEmailToBranch('')
        }
    }

    return (
        <Paper style={{padding: '2em'}} variant="outlined">
            <Box className={classes.topHeading}>
                <Typography variant="h4">
                    Branches
                </Typography>
                <Box style={{ 'flex': 1, padding: '0 2em', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                    <TextField fullWidth
                        id="search"
                        label="Search"
                        variant="outlined"
                        size="small"
                        placeholder="Filter by Name or Id"
                        style={{ marginRight: 16 }}
                        value={query}
                        onChange={(e) => { setQuery(e.target.value.toLocaleLowerCase()) }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                <Button variant="contained" color="primary" startIcon={<AddOutlinedIcon />} style={{ 'float': "right" }} onClick={handleOpen}>Add Branch</Button>
            </Box>

            <BranchCards branches={branches}
                activities={providerInfo.activities}
                handleVisibility={handleVisibility}
                handleValidate={handleValidate}
                isAdmin={isAdmin}
                sendingEmailToBranch={sendingEmailToBranch}
                onActionEmailSend={handleSendActionEmail}
                handleEdit={handleEdit}
                loading={loading}
                showValidate={user?.roles?.includes('ROLE_VALIDATOR') || user?.roles?.includes('ROLE_ADMIN')}
                handleDelete={handleDelete} />

            <Dialog open={createModalActive} onClose={handleClose} maxWidth="md" fullWidth>
                <AddBranchComponent activities={providerInfo.activities}
                    branch={selectedBranch}
                    user={user}
                    providerId={providerId}
                    providerInfo={providerInfo}
                    onUpdate={onBranchUpdate}
                    onCancel={handleClose} />
            </Dialog>
        </Paper>
    );

}
